// NOTE: these are hardcoded heights based on design,
// will need to updated manually if the design height changes

// moved here since it's being used by the messages as well as search
export const HEADER_SPACING_HEIGHT = ['87px', null, '107px'];
